import React from 'react';
import Header from './shared/Header';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
import { getRandomColor } from '../utils/colors';
const PrintsPage = () => {
  useRandomLinkColors();
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-443">
      <Header data-id="element-444" />
      <main className="flex min-h-screen pt-24 px-6 pb-16" data-id="element-445">
        {/* Mobile Layout */}
        <div className="md:hidden w-full max-w-2xl mx-auto" data-id="element-446">
          <h1 className="text-4xl font-bold mb-8 leading-tight" data-id="element-447">
            Test Print 1
          </h1>

          <div className="text-base mb-8" data-id="element-448">
            <div className="mb-1" data-id="element-449">
              'Embarrassment of Riches (Downhills Park, London)'
            </div>
            <div className="mb-4" data-id="element-450">2026</div>
            <div className="mb-4" data-id="element-451">Test Print Edition of 10 + 3 AP</div>

            <div className="mb-1" data-id="element-452">Photographed on 4×5 sheet film.</div>
            <div className="mb-1" data-id="element-453">
              Hand printed on Fomatone MG Classic fibre paper.
            </div>
            <div className="mb-4" data-id="element-454">Unframed.</div>

            <div className="mb-1" data-id="element-455">Paper Size: 10 × 8 in</div>
            <div className="mb-4" data-id="element-456">Image Size: 9 9/16 × 7 9/16 in</div>

            <div className="italic mb-4" data-id="element-457">
              All test prints are archival and signed. These editions are
              distinct from the future standard edition.
            </div>

            <div className="mb-4" data-id="element-458">
              Price: £222 (including free worldwide shipping).
            </div>

            <div className="mb-4" data-id="element-459">
              Each print is accompanied by a pressed four-leaf clover.
            </div>

            <div className="mb-8" data-id="element-460">
              <a href="https://www.paypal.com/ncp/payment/BCG3E6QBPWA34" target="_blank" rel="noopener noreferrer" className="font-bold transition-colors duration-200" onMouseEnter={e => {
              e.currentTarget.style.color = getRandomColor();
            }} onMouseLeave={e => {
              e.currentTarget.style.color = '#333333';
            }} data-id="element-461">
                BUY HERE.
              </a>
            </div>

            <div data-id="element-462">I am sending all my love and luck your way. ♡</div>
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/a9sfC1HoE84uQrrcEBRkUS/1_Madeleine-Morlet_Embarassement-of-Riches-2026.jpg" alt="Embarrassment of Riches print on table" className="w-full h-auto mb-8" data-id="element-463" />
          <img src="https://cdn.magicpatterns.com/uploads/hZMoyxeWZwznAFYfBVphHG/2_Madeleine-Morlet_Embarassement-of-Riches-2026.jpg" alt="Embarrassment of Riches print" className="w-full h-auto" data-id="element-464" />
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:flex flex-row w-full max-w-6xl mx-auto gap-12" data-id="element-465">
          <div className="w-full md:w-1/2 flex flex-col gap-8" data-id="element-466">
            <img src="https://cdn.magicpatterns.com/uploads/a9sfC1HoE84uQrrcEBRkUS/1_Madeleine-Morlet_Embarassement-of-Riches-2026.jpg" alt="Embarrassment of Riches print on table" className="w-full h-auto" data-id="element-467" />
            <img src="https://cdn.magicpatterns.com/uploads/hZMoyxeWZwznAFYfBVphHG/2_Madeleine-Morlet_Embarassement-of-Riches-2026.jpg" alt="Embarrassment of Riches print" className="w-full h-auto" data-id="element-468" />
          </div>

          <div className="w-full md:w-1/2 flex flex-col" data-id="element-469">
            <div className="max-w-2xl" data-id="element-470">
              <h1 className="text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-471">
                Test Print 1
              </h1>

              <div className="text-base mb-8" data-id="element-472">
                <div className="mb-1" data-id="element-473">
                  'Embarrassment of Riches (Downhills Park, London)'
                </div>
                <div className="mb-4" data-id="element-474">2026</div>
                <div className="mb-4" data-id="element-475">Test Print Edition of 10 + 3 AP</div>

                <div className="mb-1" data-id="element-476">Photographed on 4×5 sheet film.</div>
                <div className="mb-1" data-id="element-477">
                  Hand printed on Fomatone MG Classic fibre paper.
                </div>
                <div className="mb-4" data-id="element-478">Unframed.</div>

                <div className="mb-1" data-id="element-479">Paper Size: 10 × 8 in</div>
                <div className="mb-4" data-id="element-480">Image Size: 9 9/16 × 7 9/16 in</div>

                <div className="italic mb-4" data-id="element-481">
                  All test prints are archival and signed. These editions are
                  distinct from the future standard edition.
                </div>

                <div className="mb-4" data-id="element-482">
                  Price: £222 (including free worldwide shipping).
                </div>

                <div className="mb-4" data-id="element-483">
                  Each print is accompanied by a pressed four-leaf clover.
                </div>

                <div data-id="element-484">
                  <a href="https://www.paypal.com/ncp/payment/BCG3E6QBPWA34" target="_blank" rel="noopener noreferrer" className="font-bold transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-485">
                    BUY HERE.
                  </a>
                </div>
              </div>
            </div>
            <div className="flex-1" data-id="element-486"></div>
            <div className="text-base" data-id="element-487">
              I am sending all my love and luck your way. ♡
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default PrintsPage;